/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TeamLegalEntityAddress } from './';
import {
    TeamLegalEntityAddressFromJSON,
    TeamLegalEntityAddressFromJSONTyped,
    TeamLegalEntityAddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface TeamLegalEntityLegalInformation
 */
export interface TeamLegalEntityLegalInformation {
    /**
     * 
     * @type {string}
     * @memberof TeamLegalEntityLegalInformation
     */
    legalName?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamLegalEntityLegalInformation
     */
    registrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamLegalEntityLegalInformation
     */
    vatIdentificationNumber?: string;
    /**
     * 
     * @type {TeamLegalEntityAddress}
     * @memberof TeamLegalEntityLegalInformation
     */
    address?: TeamLegalEntityAddress;
}

/**
 * Check if a given object implements the TeamLegalEntityLegalInformation interface.
 */
export function instanceOfTeamLegalEntityLegalInformation(value: object): value is TeamLegalEntityLegalInformation {
    return true;
}

export function TeamLegalEntityLegalInformationFromJSON(json: any): TeamLegalEntityLegalInformation {
    return TeamLegalEntityLegalInformationFromJSONTyped(json, false);
}

export function TeamLegalEntityLegalInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamLegalEntityLegalInformation {
    if (json == null) {
        return json;
    }
    return {
        
        'legalName': json['legalName'] == null ? undefined : json['legalName'],
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'vatIdentificationNumber': json['vatIdentificationNumber'] == null ? undefined : json['vatIdentificationNumber'],
        'address': json['address'] == null ? undefined : TeamLegalEntityAddressFromJSON(json['address']),
    };
}

export function TeamLegalEntityLegalInformationToJSON(value?: TeamLegalEntityLegalInformation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalName': value['legalName'],
        'registrationNumber': value['registrationNumber'],
        'vatIdentificationNumber': value['vatIdentificationNumber'],
        'address': TeamLegalEntityAddressToJSON(value['address']),
    };
}

